import { computed, defineComponent, onMounted, PropType, watch } from 'vue';
import { useToast } from 'vue-toastification';
import { useStore } from 'vuex';
import { ProjectResultAction, ProjectResultGetter } from '@/store/projectResult/projectResult.module';
import { ProjectSummary } from '@/store/projectResult/projectResult.model';
import { FiscalYear } from '@/store/fiscalYear/fiscalYear.model';
import { Minister } from '@/store/minister/minister.model';
import LoadingComponent from '@/components/loading/Loading.vue';
import projectResultService from '@/store/projectResult/projectResult.service';

export default defineComponent({
  name: 'ProjectMinisterSummaryComponent',
  components: {
    LoadingComponent
  },
  props: {
    fiscalYear: {
      type: Object as PropType<FiscalYear>
    },
    minister: {
      type: Object as PropType<Minister>
    },
    isFile: {
      type: Boolean,
      default: false,
    }
  },
  setup: (props) => {
    const toast = useToast();
    const store = useStore();
    const summary = computed<ProjectSummary>(() => store.getters[ProjectResultGetter.SUMMARY]);
    const isLoading = computed(() => store.getters[ProjectResultGetter.STATUS] === 'init' || store.getters[ProjectResultGetter.STATUS] === 'loading');

    onMounted(() => {
      if (props.fiscalYear && props.minister) {
        store.dispatch(ProjectResultAction.GET_MINISTER_SUMMARY, {
          fiscalYearId: props.fiscalYear?.id,
          ministerId: props.minister?.id,
        });
      }
    });

    watch(() => [props.fiscalYear, props.minister], ([fiscalYear, minister]) => {
      if (props.fiscalYear && props.minister) {
        store.dispatch(ProjectResultAction.GET_MINISTER_SUMMARY, {
          fiscalYearId: fiscalYear?.id,
          ministerId: minister?.id,
        });
      }
    });

    const pdfClick = () => {
      projectResultService.GetMinisterPdf(props.fiscalYear?.id as number, props.minister?.id as number)
        .then((response) => {
          const a = document.createElement('a'); //Create <a>
          document.body.appendChild(a);
          a.style.display = 'none';
          a.href = window.URL.createObjectURL(response.data); //'data:pdf/application;base64,' + response.data; //Image Base64 Goes here
          a.download = (`ข้อมูลภาพรวมของ${props.minister?.fullName}_${props.fiscalYear?.name.replace(' ', '_')}.pdf`); //File name Here
          a.click(); //Downloaded file
        })
        .catch(() => {
          toast.error('ไม่สามารถเรียกข้อมูลได้');
        });
    };

    const excelClick = () => {
      projectResultService.GetMinisterExcel(props.fiscalYear?.id as number, props.minister?.id as number)
        .then((response) => {
          const a = document.createElement('a'); //Create <a>
          document.body.appendChild(a);
          a.style.display = 'none';
          a.href = window.URL.createObjectURL(response.data); //'data:pdf/application;base64,' + response.data; //Image Base64 Goes here
          a.download = (`ข้อมูลโครงการของ${props.minister?.fullName}_${props.fiscalYear?.name.replace(' ', '_')}.xlsx`); //File name Here
          a.click(); //Downloaded file
        })
        .catch(() => {
          toast.error('ไม่สามารถเรียกข้อมูลได้');
        });
    };

    return {
      summary,
      isLoading,
      pdfClick,
      excelClick,
    };
  }
});
